// Relative-time wording, mirrored from the server so a label the server
// rendered and a label this code refreshes read the same.
//
// distanceOfTimeInWords follows ActionView's distance_of_time_in_words
// (without seconds), thresholds and leap-year handling included.
// waitingLabel follows the task sheet's "12m" / "5h" / "1 day" / "47 days"
// wording, which coarsens as the wait grows.

const MINUTES_IN_YEAR = 525600
const MINUTES_IN_QUARTER_YEAR = 131400
const MINUTES_IN_THREE_QUARTERS_YEAR = 394200

function plural(count, one, other) {
  return count === 1 ? one : other.replace("%{count}", String(count))
}

function leapYearsBetween(fromDate, toDate) {
  let fromYear = fromDate.getUTCFullYear()
  if (fromDate.getUTCMonth() + 1 >= 3) fromYear += 1
  let toYear = toDate.getUTCFullYear()
  if (toDate.getUTCMonth() + 1 < 3) toYear -= 1
  if (fromYear > toYear) return 0

  const leapsUpTo = (year) => Math.floor(year / 4) - Math.floor(year / 100) + Math.floor(year / 400)
  return leapsUpTo(toYear) - leapsUpTo(fromYear - 1)
}

export function distanceOfTimeInWords(fromMs, toMs) {
  let from = fromMs
  let to = toMs
  if (from > to) [from, to] = [to, from]

  const minutes = Math.round((to - from) / 60000)

  if (minutes <= 1) return minutes === 0 ? "less than a minute" : "1 minute"
  if (minutes < 45) return plural(minutes, "1 minute", "%{count} minutes")
  if (minutes < 90) return "about 1 hour"
  if (minutes < 1440) return plural(Math.round(minutes / 60), "about 1 hour", "about %{count} hours")
  if (minutes < 2520) return "1 day"
  if (minutes < 43200) return plural(Math.round(minutes / 1440), "1 day", "%{count} days")
  if (minutes < 86400) return plural(Math.round(minutes / 43200), "about 1 month", "about %{count} months")
  if (minutes < 525600) return plural(Math.round(minutes / 43200), "1 month", "%{count} months")

  const minutesWithOffset = minutes - leapYearsBetween(new Date(from), new Date(to)) * 1440
  const remainder = minutesWithOffset % MINUTES_IN_YEAR
  const years = Math.floor(minutesWithOffset / MINUTES_IN_YEAR)
  if (remainder < MINUTES_IN_QUARTER_YEAR) return plural(years, "about 1 year", "about %{count} years")
  if (remainder < MINUTES_IN_THREE_QUARTERS_YEAR) return plural(years, "over 1 year", "over %{count} years")
  return plural(years + 1, "almost 1 year", "almost %{count} years")
}

export function waitingLabel(sinceMs, nowMs) {
  const waited = Math.max(nowMs - sinceMs, 0) / 1000
  const days = Math.floor(waited / 86400)
  if (days >= 60) return `${Math.round(days / 30)} months`
  if (days >= 2) return `${days} days`
  if (days === 1) return "1 day"

  const hours = Math.floor(waited / 3600)
  if (hours > 0) return `${hours}h`
  return `${Math.max(Math.floor(waited / 60), 1)}m`
}
